import { DEFAULT_MIDDLE_DIALOG_WIDTH } from '@abb-procure/constants';
import { Injectable, inject } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import type {
  StatusWorkflowDialog,
  StatusWorkflowDialogData,
} from '../components/status-workflow-dialog/status-workflow-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class StatusWorkflowDialogService {
  private readonly dialog = inject(MatDialog);

  async openStatusWorkflowDialog(
    data: StatusWorkflowDialogData,
  ): Promise<MatDialogRef<StatusWorkflowDialog, string>> {
    const module =
      await import('../components/status-workflow-dialog/status-workflow-dialog.component');

    return this.dialog.open<
      StatusWorkflowDialog,
      StatusWorkflowDialogData,
      string
    >(module.StatusWorkflowDialog, {
      data,
      panelClass: ['status-workflow-dialog'],
      width: DEFAULT_MIDDLE_DIALOG_WIDTH,
    });
  }
}
